// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCev9RFcoe0bF92dznl2sAwpTE5FU9O8AE",
  authDomain: "spark-519f6.firebaseapp.com",
  projectId: "spark-519f6",
  storageBucket: "spark-519f6.appspot.com",
  messagingSenderId: "753110681584",
  appId: "1:753110681584:web:93a90ea097790a42b8bf35",
};

// Initialize Firebase
export const firebase = initializeApp(firebaseConfig);
export const auth = getAuth(firebase);
